import type React from 'react';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import ContentBox3 from '@zg-rentals/multibrand-ui/lib/ContentBox3';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import PaymentPlanRequestSentIcon from '@assets/payment-plan-request-sent.svg';
import { centsToDollars } from '@common/paymentsUtils/currencyUtils';

type Props = {
  onClose: () => void;
  paymentPlanDetails: Record<string, any>;
  goToInstallmentRequestPage: () => void;
};

const PaymentPlanInstallmentRequestSentPage: React.FC<React.PropsWithChildren<Props>> = (props: Props): JSX.Element => {
  return (
    <>
      <Row>
        <Col>
          <img src={PaymentPlanRequestSentIcon as unknown as string} alt="" />
        </Col>
      </Row>
      <Row>
        <Col>
          <Text emphasize type="h4">
            Payment plan installment {props.paymentPlanDetails.paymentPlanNumber} requested
          </Text>
        </Col>
      </Row>
      <Row>
        <Col>
          <Text>If the payment plan has more installments, you can add and send another payment request now.</Text>
        </Col>
      </Row>
      <SpacerRow size="sm" />
      <ContentBox3>
        <Row>
          <Col md={12}>
            <Text inline className="boldText">
              Request Details
            </Text>
          </Col>
        </Row>
        <Row>
          <Col md={9}>
            <Text inline>Payment Plan Installment {props.paymentPlanDetails.paymentPlanNumber}</Text>
            <Text>{props.paymentPlanDetails.notes}</Text>
            <Text>{props.paymentPlanDetails.tenantName}</Text>
          </Col>
          <Col md={3}>
            <Text className="boldText">{centsToDollars(props.paymentPlanDetails.amount)}</Text>
          </Col>
        </Row>
      </ContentBox3>
      <SpacerRow />
      <Row>
        <Col>
          <Button type="primary" full onClick={props.goToInstallmentRequestPage}>
            Request another payment
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button type="tertiary" full onClick={props.onClose}>
            No more payments needed
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default PaymentPlanInstallmentRequestSentPage;
